<template>
  <v-container>
    {{ label }}
    <!-- {{ vModel }} -->
    <v-row>
      <v-col>
        <v-list :key="itemsKey">
          <draggable
            class="drag-drop-list"
            style="width:100%"
            :list="localItems"
          >
            <v-list-item
              class="pointer"
              v-for="(item, index) in localItems"
              :key="index"
            >
              <v-card class="pa-3 mb-2">
                <v-row>
                  <v-col cols="2"
                    ><v-btn small icon @click="deleteRec(index)"
                      ><v-icon color="error">mdi-close</v-icon></v-btn
                    ></v-col
                  >
                  <v-col>
                    <v-card-title>{{ index + 1 }}</v-card-title></v-col
                  >
                </v-row>

                <v-card-text>
                  <div v-for="field in fields" :key="field">
                    {{ item[field] || "N/A" }}
                  </div>
                </v-card-text>
              </v-card>
              <!-- <v-list-item-title>{{ item.text }}</v-list-item-title> -->

              <!-- <v-switch v-model="item.show"></v-switch> -->
            </v-list-item>
          </draggable>
        </v-list>
        <!-- <draggable v-model="localItems" item-key="id" class="drag-drop-list">
          <template #item="{ element }">
            <v-card class="pa-3 mb-2">
              <v-card-text>
                <div v-for="field in fields" :key="field">
                  <strong>{{ field }}:</strong> {{ element[field] || "N/A" }}
                </div>
              </v-card-text>
            </v-card>
          </template>
        </draggable> -->
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import draggable from "vuedraggable";
import * as fun from "../plugins/common";
export default {
  name: "DragDropList",
  components: {
    draggable,
  },
  props: {
    label: String,
    sortValue: String,
    vModel: {
      type: Array,
      required: true,
    },
    nameKey: String,
    fields: {
      type: Array,
    },
  },
  mounted() {
    console.log(this.fields);
  },
  data() {
    return {
      itemsKey: 0,
      localItems: [
        ...this.vModel.sort((a, b) => {
          return a[this.sortValue] - b[this.sortValue];
        }),
      ], // Local copy of the items for reordering
    };
  },
  watch: {
    localItems: {
      deep: true,
      handler(newValue) {
        var d = fun.clone(newValue);
        d.forEach((element, i) => {
          element[this.sortValue] = i + 1;
        });
        this.$emit("input", d); // Emit updated items array
        this.$root.$emit("sortingChanged", this);
      },
    },
  },
  methods: {
    defaultTemplate: {
      functional: true,
      render(h, context) {
        return h("v-card", { class: "pa-3 mb-2" }, [
          h("v-card-text", context.props.item.name || "Unnamed Item"),
        ]);
      },
    },
    deleteRec(i) {
      var that = this;
      var key = this.vModel[i][this.nameKey] || this.vModel[i];
      this.$root.$confirm
        .open("Delete", "Confirm deleting " + fun.capitalize(key) + "?", {
          color: "red",
        })
        .then((confirm) => {
          if (confirm) {
            console.log(key);
            this.deletedItem = that.vModel[i];
            that.vModel.splice(i, 1);
            that.localItems = [
              ...this.vModel.sort((a, b) => {
                return a[this.sortValue] - b[this.sortValue];
              }),
            ];
            // this.$root.$emit("itemsDeleted", this);
          }
        });
    },
  },
};
</script>

<style scoped>
.drag-drop-list {
  display: flex;
  flex-direction: column;
}
</style>
